import { Component, Input, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppdataService } from '../../service/appdata.service';

@Component({
  selector: 'rr-agent-select',
  standalone: false,
  templateUrl: './agent-select.component.html',
  styleUrl: './agent-select.component.scss'
})
export class AgentSelectComponent {
  @Input() options: Array<any> = [];
  @Input() control: FormControl = new FormControl();
  @Input() optionName: string = 'name';
  @Input() optionValue: string = 'id';
  @Input() iconType: string = 'image';
  @Input() preselectedValue: any = null;

  selectedName: string = '';
  selectedIcon: string = '';
  showOptions: boolean = false;
  elementWidth: string = 'auto';
  elementHeight: string = 'auto';

  constructor(
    private appdata: AppdataService
  ) {
    appdata.agents.subscribe((data: any) => {
      this.options = data;
    })
  }

  ngOnInit() {

    this.initializeSelectedOption();
    if (this.preselectedValue && this.control.value === null) {
      setTimeout(() => {
        this.updateSelectedOption(this.preselectedValue);
      }, 50);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.initializeSelectedOption();
    }
    if (changes['preselectedValue']) {
      this.updateSelectedOption(this.preselectedValue);
    }
  }

  initializeSelectedOption() {

    const selectedOption = this.options?.find(option => option[this.optionValue] === this.control.value);
    if (selectedOption) {
      this.selectedName = selectedOption[this.optionName];
      this.selectedIcon = selectedOption.icon || '';
    }
  }

  updateSelectedOption(value: any) {
    const selectedOption = this.options.find(option => option[this.optionValue] === value);
    if (selectedOption) {
      this.selectedName = selectedOption[this.optionName];
      this.selectedIcon = selectedOption.icon || '';
    }

  }

  selectOption(option: any) {
    if (option === undefined) {
      this.selectedName = '';
      this.selectedIcon = '';
      this.control.setValue(null);
      this.showOptions = false;
      return;
    }
    this.selectedName = option[this.optionName];
    this.selectedIcon = option.icon || '';
    this.showOptions = false;
    this.control?.setValue(option[this.optionValue]);

    this.onTouched();
  }
  getSelectedOption() {
    return this.options.find(option => option[this.optionValue] === this.control.value);
  }
  toggleOptions(eventTarget: any) {
    this.showOptions = !this.showOptions;

    if (this.showOptions) {
      setTimeout(() => {
        const element = (eventTarget as HTMLElement).closest('.mainselect');
        if (element) {
          // const width = element.clientWidth;
          let height = element.clientHeight;
          // this.elementWidth = width + 2 + 'px';
          this.elementHeight = height + 10 + 'px';
        } else {
          // this.elementWidth = 'auto';
          this.elementHeight = 'auto';
        }
      }, 0);
    }
  }

  writeValue(value: any): void {
    if (value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any): void {
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
